/*eslint-disable*/
import api from '../'

class divideItRightGameItems {
    // POST: couples
    static getItemsByRequest (params) {
        return api.axios.get('/divideItRight/items', { params }).then(response => response.data.items);
    }
}

export default divideItRightGameItems;
